import { render } from "./navbar.vue?vue&type=template&id=0e6a6f8c"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__